import React, { ReactElement } from 'react';
import PlaceIcon from '@material-ui/icons/Place';

import { Location } from 'types/common';

interface LocationCardProps {
  location: Location;
  onBrowseLocation: (location: Location) => void;
}
const LocationCard = ({ location, onBrowseLocation }: LocationCardProps): ReactElement => {
  return (
    <>
      <div className="flex border-2 items-center	 border-mute mt-2 p-4">
        <div className="w-1/6">
          <div className="text-secondary-actual cursor-pointer">
            <PlaceIcon color="inherit" style={{ fontSize: 45 }} />
          </div>
        </div>
        <div className="w-3/5 text-sm">
          <h3 className="text-base font-semibold">{location?.name}</h3>
          <p>{location?.address1}</p>
          <p>{location?.address2}</p>
          <p>
            {location?.city}, {location?.state} {location?.zipCode}
          </p>
        </div>
        <button
          className="w-1/3 self-end border-tertiary border rounded-md bg-tertiary text-white py-1 text-xs"
          onClick={() => onBrowseLocation(location)}
        >
          Browse This Location
        </button>
      </div>
    </>
  );
};
export default LocationCard;
